import React from 'react';
import RecipientStep from './RecipientStep';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import DirectReportsStore from 'stores/coaching/DirectReportsStore';
import DirectReportsActions from 'actions/coaching/DirectReportsActions';
import UserActions from 'actions/UserActions';
import UserStore from 'stores/UserStore';
import {List} from 'immutable';
import Loading from 'components/pure/utils/Loading';
import {associateBy} from 'utils/associateBy';

class RecipientStepContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {directReportsLoaded: false};
  }

  static getStores() {
    return [AuthStore, DirectReportsStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      sessionUser: AuthStore.getState().user,
      users: UserStore.getState().users,
      directReports: associateBy(DirectReportsStore.getState().directReports, u => u.id),
    };
  }

  async componentDidMount() {
    this.setState({directReportsLoaded: false});

    const directReports = this.props.managerId
      ? await DirectReportsActions.directReports(this.props.managerId)
      : new List();

    if (this.props.sessionUser.isAdmin() || directReports.size === 0) {
      await UserActions.fetchAll();
    }

    this.setState({directReportsLoaded: true});
  }

  render() {
    const {directReportsLoaded} = this.state;

    if (!directReportsLoaded) {
      return (
        <div className="coaching-step">
          <Loading />
        </div>
      );
    }

    return <RecipientStep {...this.props} />;
  }
}

const connectedComponent = connectToStores(RecipientStepContainer);
connectedComponent.title = RecipientStep.title;
connectedComponent.validate = RecipientStep.validate;
export default connectedComponent;
